import { isNil, isEmpty } from 'lodash/lang';
import { mapGetters, mapActions } from 'vuex';
import MainLayout from '@layouts/main-layout';
import { authComputed } from '@state/helpers';
import { trackMessages } from '@utils/analytics/pages';
import routeEnum from '@enums/route-enum';
import { getHeaderRoutes, getHeaderExtraRoutes } from '@utils/header/get-header-routes';
import EnquiryMessages from '@components/enquiry-messages';
import NProgress from 'nprogress/nprogress';

export default {
  components: { MainLayout, EnquiryMessages },
  page: {
    title: routeEnum.MESSAGES.title,
    meta: [{ name: 'description', content: routeEnum.MESSAGES.title }],
  },
  props: ['uuid', 'providerUuid'],
  data() {
    return {
      extraRoutes: getHeaderExtraRoutes(),
    };
  },

  computed: {
    ...authComputed,

    ...mapGetters({
      getEnquiryByUuid: 'connector/getEnquiryByUuid',
      getProviderByUuid: 'users/getProviderByUuid',
      enquiries: 'connector/getEnquiries',
      getMessages: 'messages/getMessages',
      overviews: 'messages/getOverviews',
    }),

    routes() {
      return getHeaderRoutes(this.overviews, this.enquiries);
    },

    selected() {
      return this.routes ? this.routes[1] : routeEnum.MESSAGES;
    },

    enquiry() {
      return this.getEnquiryByUuid(this.uuid);
    },

    provider() {
      return this.getProviderByUuid(this.providerUuid);
    },
  },

  methods: {
    ...mapActions({
      listOverviews: 'messages/listOverviews',
      listMessages: 'messages/listMessages',
      fetchUser: 'users/fetchUser',
    }),

    /**
     * This function fetches a provider.
     * If we do have the provider we fetch it and await.
     * If we already it, we update it without awaiting.
     */
    async fetchProvider() {
      if (!isNil(this.provider) && this.provider.uuid === this.providerUuid) {
        this.fetchUser(this.providerUuid);

        return;
      }

      await this.fetchUser(this.providerUuid);
    },

    getLastMessage() {
      const messages = this.getMessages(this.uuid, this.providerUuid);
      if (isNil(messages) || isEmpty(messages.list)) {
        return null;
      }

      return messages.list[messages.list.length - 1];
    },
  },

  async created() {
    NProgress.start();

    if (isNil(this.enquiry)) {
      this.$router.push({ path: routeEnum.DASHBOARD.path });

      return;
    }

    await this.fetchProvider();
    if (isNil(this.provider)) {
      this.$router.push({ path: routeEnum.DASHBOARD.path });

      return;
    }

    await this.listOverviews();
    await this.listMessages({ enquiryUuid: this.uuid, providerUuid: this.providerUuid });
    trackMessages(this.enquiry, this.provider, this.getLastMessage());

    NProgress.done();
  },
};
